import React from 'react';
import Script from 'next/script';

import { GOOGLE_IMA_SDK_URL } from 'common/constants';

const VideoJsAdScripts = ({
  hasAdFreeCamPermissions,
  onVideoJsGoogleImaLoaded,
  onVideoJsGoogleImaError,
}: {
  hasAdFreeCamPermissions: boolean;
  onVideoJsGoogleImaLoaded: () => void;
  onVideoJsGoogleImaError: (e: Event) => void;
}) =>
  !hasAdFreeCamPermissions ? (
    <>
      {/* This script must be loaded directly from a Google domain to avoid error. */}
      <Script
        data-testid="google-ima3-script"
        id="google-ima3"
        strategy="afterInteractive"
        src={GOOGLE_IMA_SDK_URL}
        onReady={onVideoJsGoogleImaLoaded}
        onError={onVideoJsGoogleImaError}
      />
    </>
  ) : null;

export default VideoJsAdScripts;
